import { render, staticRenderFns } from "./Notifications-details.vue?vue&type=template&id=22d00c92&scoped=true&"
import script from "./Notifications-details.vue?vue&type=script&lang=js&"
export * from "./Notifications-details.vue?vue&type=script&lang=js&"
import style0 from "./Notifications-details.vue?vue&type=style&index=0&id=22d00c92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d00c92",
  null
  
)

export default component.exports